<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="product.name"
          label="Internal Name"
          outlined
          :rules="[$rules.required]"
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        v-if="product.category"
        cols="12"
      >
        <v-select
          v-model="product.category.id"
          :items="categories"
          item-text="name"
          item-value="id"
          label="Category"
          outlined
          :rules="[$rules.required]"
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        v-if="product.fold"
        cols="12"
        sm="6"
      >
        <v-select
          v-model="product.fold.id"
          :items="folds"
          item-text="name"
          item-value="id"
          label="Fold"
          outlined
          :rules="[$rules.required]"
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        v-if="product.units"
        cols="12"
        sm="6"
      >
        <v-select
          v-model="product.units.id"
          :items="units"
          item-text="name"
          item-value="id"
          label="Units"
          outlined
          :rules="[$rules.required]"
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="product.width"
          label="Width"
          outlined
          :rules="[$rules.required]"
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="product.height"
          label="Height"
          outlined
          :rules="[$rules.required]"
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="product.bleedTop"
          label="Bleed Top"
          outlined
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="product.bleedBottom"
          label="Bleed Bottom"
          outlined
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="product.bleedLeft"
          label="Bleed Left"
          outlined
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="product.bleedRight"
          label="Bleed Right"
          outlined
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="product.safetyTop"
          label="Safety Top"
          hint="Safe-zone margin inside the trim line (same units as bleed)."
          persistent-hint
          outlined
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="product.safetyBottom"
          label="Safety Bottom"
          outlined
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="product.safetyLeft"
          label="Safety Left"
          outlined
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="product.safetyRight"
          label="Safety Right"
          outlined
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="product.sizeDisplay"
          label="Size Display"
          outlined
          :rules="[$rules.required]"
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col cols="12">
        <v-select
          v-model="product.pageCount"
          :items="numbers(1, 16)"
          item-text="name"
          item-value="id"
          label="Page Count"
          outlined
          :rules="[$rules.required]"
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col cols="12">
        <v-select
          v-model="product.viewingDistanceInFeet"
          label="Viewing Distance (ft)"
          :items="numbers(0, 50)"
          item-text="name"
          item-value="id"
          outlined
          :rules="[$rules.requiredAllowEmpty]"
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col
        v-if="product.category && !adding"
        cols="12"
      >
        <v-select
          v-model="product.similarMetricProductId"
          :items="similar_metric_products(product.category.id)"
          item-text="name"
          item-value="id"
          label="Similar Metric Product"
          outlined
          hide-details="auto"
          dense
        />
      </v-col>
    </v-row>
    <v-row dense>
      <!-- <v-col cols="12" v-if="!adding">
        <v-switch
          v-model="product.active"
          label="Active"
          color="primary"
          inset
          hide-details
          outlined
          dense
        />
      </v-col> -->

      <v-col cols="12">
        <v-switch
          v-model="product.allowTemplateCreation"
          label="Allow template creation"
          color="primary"
          inset
          hide-details
          outlined
          dense
        />
      </v-col>

      <v-col cols="12">
        <v-switch
          v-model="product.isCategoryDefault"
          label="Is category default"
          color="primary"
          inset
          hide-details
          outlined
          dense
        />
      </v-col>

      <v-col cols="12">
        <v-switch
          v-model="product.usePresentationImage"
          label="Use presentation image"
          color="primary"
          inset
          hide-details
          outlined
          dense
        />
      </v-col>

      <v-col cols="12">
        <v-switch
          v-model="product.enable3dView"
          label="Enable 3D View"
          color="primary"
          inset
          hide-details
          outlined
          dense
        />
      </v-col>

      <template v-if="product.enable3dView">
        <v-col
          cols="12"
          class="pt-4"
        >
          <v-select
            v-model="product.environmentType"
            label="Environment"
            :items="['paper', 'hardware']"
            outlined
            hide-details="auto"
            dense
          />
        </v-col>

        <v-col
          cols="12"
          class="pt-4"
        >
          <OutlinedInput
            dense
            label="3d Model Url"
            :legend-width="80"
          >
            <v-row>
              <v-col
                class="my-auto text-truncate d-block"
                cols="auto"
              >
                <div
                  v-if="product.modelUrl"
                  class="info--text cursor-pointer text-decoration-underline"
                  @click="$root.$clipboard($event.clientX, $event.clientY, product.modelUrl)"
                >
                  Copy
                </div>
                <template v-else>None</template>
              </v-col>
              <v-spacer />
              <v-col
                cols="auto"
                class="my-auto"
              >
                <v-btn
                  :loading="saving"
                  small
                  @click="$refs.hiddenUpload.click()"
                >
                  Change
                </v-btn>
                <input
                  ref="hiddenUpload"
                  type="file"
                  accept=".glb"
                  style="display: none"
                  @change="setModelUrl($event)"
                />
              </v-col>
            </v-row>
          </OutlinedInput>
        </v-col>

        <v-col
          cols="12"
          class="pt-4"
        >
          <v-textarea
            v-model="product.foldAnimationSpec"
            label="3D Fold Animation JSON"
            hint="Paste the Builder's exported product.json. Leave blank for no fold — the viewer hides the Open/Close toggle."
            persistent-hint
            :rules="[$rules.jsonValid]"
            outlined
            dense
            rows="4"
          />
        </v-col>
      </template>

      <v-col
        v-if="product.usePresentationImage"
        cols="12"
        class="pt-4"
      >
        <v-text-field
          v-model="product.presentationKey"
          label="Presentation Key"
          outlined
          :rules="[$rules.required]"
          hide-details="auto"
          dense
        />
      </v-col>

      <v-col cols="12">
        <v-switch
          v-model="product.shapedByGuide"
          label="Shaped by guide (non-rectangular)"
          color="primary"
          inset
          hide-details
          outlined
          dense
        />
      </v-col>

      <v-col cols="12">
        <v-switch
          v-model="product.useBleedGuides"
          label="Use bleed guides"
          color="primary"
          inset
          hide-details
          outlined
          dense
        />
      </v-col>

      <v-col cols="12">
        <v-switch
          v-model="product.allowPageDuplication"
          label="Can duplicate pages"
          color="primary"
          inset
          hide-details
          outlined
          dense
        />
      </v-col>

      <v-col cols="12">
        <v-switch
          v-model="product.allowPageCountChange"
          label="Can add/remove page"
          color="primary"
          inset
          hide-details
          outlined
          dense
        />
      </v-col>

      <v-col cols="12">
        <v-switch
          v-model="product.disablePrintPageSelection"
          label="Disable page selection in checkout"
          color="primary"
          inset
          hide-details
          outlined
          dense
        />
      </v-col>

      <v-col
        cols="12"
        class="pt-4"
      >
        <v-text-field
          v-model="product.resourceUrl"
          label="Resource url"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12">
        <OutlinedInput
          dense
          label="Template Resource Url"
          :legend-width="142"
        >
          <v-row>
            <v-col
              class="my-auto text-truncate d-block"
              cols="auto"
            >
              <div
                v-if="product.templateResourceUrl"
                class="info--text cursor-pointer text-decoration-underline"
                @click="
                  $root.$clipboard($event.clientX, $event.clientY, product.templateResourceUrl)
                "
              >
                Copy
              </div>
              <template v-else>None</template>
            </v-col>
            <v-spacer />
            <v-col
              cols="auto"
              class="my-auto"
            >
              <v-btn
                :loading="saving"
                small
                @click="$refs.hiddenTemplateUpload.click()"
              >
                Change
              </v-btn>
              <input
                ref="hiddenTemplateUpload"
                type="file"
                style="display: none"
                @change="setTemplateResourceUrl($event)"
              />
            </v-col>
          </v-row>
        </OutlinedInput>
      </v-col>
    </v-row>
    <Portal :to="getDrawerAppend($enums.DRAWER.EDIT_PRODUCT)">
      <v-btn
        color="primary"
        :loading="saving"
        block
        @click="save"
      >
        Save
      </v-btn>
    </Portal>
  </v-form>
</template>

<script>
import OutlinedInput from '@/components/common/OutlinedInput';
import { mapGetters } from 'vuex';

export default {
  name: 'ProductForm',

  components: { OutlinedInput },

  data() {
    return {
      loading: false,
      valid: false,
      saving: false
    };
  },

  computed: {
    adding() {
      return !this.product.id;
    },
    product: {
      get() {
        return this.$store.getters['products/edit_product'];
      },
      set(val) {
        this.$store.dispatch('products/edit', val);
      }
    },
    ...mapGetters({
      units: 'lookup/units',
      folds: 'lookup/folds',
      categories: 'lookup/non_parent_categories',
      similar_metric_products: 'lookup/similar_metric_products',
      numbers: 'lookup/numbers'
    })
  },

  async mounted() {},

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('products/save', this.product)
        .then((id) => {
          this.$emit('save', id);
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    async setModelUrl(e) {
      this.saving = true;
      this.$store
        .dispatch('products/setModelUrl', {
          coreProductId: this.product.id,
          file: e.target.files[0]
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    setTemplateResourceUrl(e) {
      this.saving = true;
      this.$store
        .dispatch('products/setTemplateResourceUrl', {
          coreProductId: this.product.id,
          file: e.target.files[0]
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
